import React from "react";
import { COLORS } from "../constants/colors";
import Seo from "../components/Seo";
import "./Home.css";
import appPreview from "../assets/budgetmate_app_preview.png";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.budgetmate&pcampaignid=web_share";

function Home() {
  return (
    <div className="home-container">
      <Seo
        title="BudgetMate — Smart Budget & Expense Tracker"
        description="BudgetMate helps you track expenses, manage salary, and stay in control of your finances with multi-language support and customizable categories."
      />

      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero-top">
          {/* LEFT */}
          <div className="hero-content">
            <span className="hero-badge">Smart Money Management</span>

            <h1 className="hero-title" style={{ color: COLORS.primary }}>
              BudgetMate – Smart Personal Budget Manager
            </h1>

            <p className="hero-subtitle">
              BudgetMate is your all-in-one personal finance companion — designed
              to help you manage your monthly salary, track daily expenses, and
              build smarter saving habits without any complexity.
            </p>

            <p className="hero-subtitle">
              With our latest update, BudgetMate becomes even more powerful and
              personal. You can now use the app in both Hindi and English 🌐,
              making it accessible and comfortable for users across different
              regions.
            </p>
          </div>

          {/* RIGHT */}
          <div className="hero-image-block">
            <img src={appPreview} alt="BudgetMate App Preview" />

            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="playstore-btn"
            >
              <span className="playstore-small">GET IT ON</span>
              <span className="playstore-big">Google Play</span>
            </a>
          </div>
        </div>

        {/* FULL WIDTH CONTENT */}
        <div className="hero-bottom">
          <p>
            We’ve also introduced customizable category accounts ⚙️, so you can
            organize and manage your expenses exactly the way you want.
            BudgetMate adapts to your style — not the other way around.
          </p>

          <p>
            The improved Budget tab now gives you a clearer and smarter overview
            of your finances 📊. With better insights, you can understand your
            spending, stay in control, and plan ahead with confidence.
          </p>

          <p>
            No confusing finance terms. No unnecessary features. Just a clean,
            fast, and reliable experience that helps you take full control of
            your money — every single day.
          </p>
        </div>
      </section>

      {/* FEATURES SECTION */}
      <section className="features">
        <h2 style={{ color: COLORS.primary }}>
          What BudgetMate Helps You Do
        </h2>

        <div className="feature-list">
          <div className="feature-card">
            <h3>Salary Tracking</h3>
            <p>
              Add your monthly salary and automatically plan your expenses
              without manual calculations.
            </p>
          </div>

          <div className="feature-card">
            <h3>Expense Management</h3>
            <p>
              Track daily expenses category-wise and always know where your
              money goes.
            </p>
          </div>

          <div className="feature-card">
            <h3>Monthly Summary</h3>
            <p>
              View clear monthly summaries with totals, balances, and spending
              insights.
            </p>
          </div>

          <div className="feature-card">
            <h3>Multi-Language Support</h3>
            <p>
              Use BudgetMate in both Hindi and English for a more comfortable
              and accessible experience.
            </p>
          </div>

          <div className="feature-card">
            <h3>Custom Categories</h3>
            <p>
              Customize category accounts based on your personal needs for
              better and more flexible expense tracking.
            </p>
          </div>

          <div className="feature-card">
            <h3>Simple & Secure</h3>
            <p>
              Clean UI, fast performance, and secure data handling built for
              everyday users.
            </p>
          </div>
        </div>
      </section>

      {/* INFO SECTION */}
      <section className="info">
        <h2 style={{ color: COLORS.primary }}>Why BudgetMate?</h2>
        <p style={{ color: COLORS.text }}>
          BudgetMate is designed for people who want a{" "}
          <strong>stress-free and flexible way to manage money</strong>. With
          support for multiple languages and customizable categories, you get
          full control over how you track, plan, and save — all without
          complicated finance terms.
        </p>
      </section>
    </div>
  );
}

export default Home;